import TeamListView from './TeamListView';
export default TeamListView;
